var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9435 12.9285C17.6828 11.6685 18.8154 9.62935 18.8154 7.33213C18.8154 3.51474 15.6888 0.409058 11.8457 0.409058C8.0026 0.409058 4.876 3.51474 4.876 7.33213C4.876 9.62935 6.00856 11.6685 7.74788 12.9285C3.42426 14.5719 0.345703 18.7359 0.345703 23.6014C0.345703 25.7009 2.06533 27.4091 4.17904 27.4091H19.5124C21.6261 27.4091 23.3457 25.7009 23.3457 23.6014C23.3457 18.7359 20.2671 14.5719 15.9435 12.9285ZM6.96693 7.33213C6.96693 4.65998 9.15555 2.486 11.8457 2.486C14.5359 2.486 16.7245 4.65998 16.7245 7.33213C16.7245 10.0043 14.5359 12.1783 11.8457 12.1783C9.15555 12.1783 6.96693 10.0043 6.96693 7.33213ZM19.5124 25.3321H4.17904C3.21827 25.3321 2.43664 24.5557 2.43664 23.6013C2.43664 18.4478 6.65747 14.2552 11.8458 14.2552C17.034 14.2552 21.2549 18.4477 21.2549 23.6013C21.2548 24.5557 20.4732 25.3321 19.5124 25.3321Z",
    fill: "#757686"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.e2380e5f674ca0782069881310986f93.svg";
export { ForwardRef as ReactComponent };